module.exports = __webpack_public_path__ + "assets/img/Travel_map.8df4b702.svg";